<div mat-dialog-title id="support-title-rs">
  <div class="relative flex items-start justify-between px-4 py-2">
    <shared-read-speaker
      style="position: absolute; top: 0"
      idButtonDom="rs-support-title"
      targetIdToRead="support-title-rs"></shared-read-speaker>

    <h2>{{ support['support.title'] }}</h2>
    <button mat-icon-button mat-dialog-close class="ml-auto">
      <span class="icon-{{ environment }}-close1" aria-hidden="true"></span>
    </button>
  </div>
</div>
<div mat-dialog-content class="relative">
  @if (!supportType) {
    <shared-read-speaker
      style="position: absolute; top: 0"
      idButtonDom="support-choices-rs"
      targetIdToRead="rs-support-choices"></shared-read-speaker>
  }
  @if (!supportType) {
    <div class="choices flex" id="rs-support-choices">
      <button class="keep choice" (click)="supportType = supportTypes.JIRA">
        <span class="icon-library-lighting"></span>
        <span class="btn-title-main" [innerHTML]="support['support.technical']"></span>
        <p class="legende" [innerHTML]="support['support.technical-explanation']"></p>
      </button>
      <button class="keep choice" (click)="supportType = supportTypes.CLIENT">
        <span class="icon-library-confusion"></span>
        <span class="btn-title-main" [innerHTML]="support['support.business']"></span>
        <p class="legende" [innerHTML]="support['support.business-explanation']"></p>
      </button>
    </div>
  }

  @if (!!supportType) {
    <form [formGroup]="formSupport" id="rs-support-form">
      <shared-read-speaker
        style="position: absolute; top: 0"
        idButtonDom="support-form-rs"
        targetIdToRead="rs-support-form"></shared-read-speaker>
      <div class="form-field-label">
        <label for="mail">{{ support['support.placeholder-mail'] }}*</label>
        <mat-form-field appearance="outline">
          <input
            id="mail"
            matInput
            type="email"
            [placeholder]="support['support.placeholder-mail']"
            formControlName="mail" />
        </mat-form-field>
      </div>
      <div class="form-field-label">
        <label for="title">{{ support['support.placeholder-title'] }}*</label>
        <mat-form-field appearance="outline">
          <input
            id="title"
            matInput
            type="text"
            [placeholder]="support['support.placeholder-title']"
            formControlName="title" />
        </mat-form-field>
      </div>
      <div class="form-field-label">
        <label for="message">{{ support['support.placeholder-message'] }}*</label>
        <mat-form-field appearance="outline">
          <textarea
            id="message"
            matInput
            type="text"
            [placeholder]="support['support.placeholder-message']"
            formControlName="message"
            rows="5"></textarea>
          <mat-hint align="end">{{ formSupport.get('message').value.length }} / 1000</mat-hint>
        </mat-form-field>
      </div>
      <div class="form-control block-upload">
        <label>{{ support['support.label-file'] }}</label>
        <input #uploader accept="*" hidden type="file" (change)="addFile($event)" />
        <button mat-flat-button color="primary" class="btn-control control-button-blue" (click)="uploader.click()">
          <span class="label" [innerHTML]="support['support.placeholder-file']"></span>
        </button>
      </div>
      <div class="doc-joint">
        @if (!!fileUploaded) {
          <p>
            <span class="icon-learniz-paperclip"></span>
            <strong [innerHTML]="support['support.file-attachment']"></strong>
            {{ fileUploaded.name }}
            <button (click)="clearFiles()" class="keep icon-learniz-close delete-doc"></button>
          </p>
        }
      </div>
      @if (errorMessage) {
        <p class="block-alert">
          <span class="alert error">{{ errorMessage }}</span>
        </p>
      }
      @if (showErrorFileLimit) {
        <p class="block-alert">
          <span class="alert error" [innerHTML]="support['support.limit-file']"></span>
        </p>
      }
    </form>
  }
</div>
<div mat-dialog-actions align="center" class="relative" id="rs-support-form-button">
  <shared-read-speaker
    style="position: absolute; top: 0; left: 0"
    idButtonDom="support-form-button-rs"
    targetIdToRead="rs-support-form-button"></shared-read-speaker>
  @if (!!supportType) {
    <button
      type="submit"
      mat-flat-button
      color="accent"
      [disabled]="!formSupport.valid || loader"
      (click)="sendTicket()">
      {{ support['support.send'] }}
    </button>
  }
  <button type="button" mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>
    {{ support['support.close'] }}
  </button>
</div>
